import { styled, keyframes } from '@mui/material/styles'

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 60vh;
`

export const Spinner = styled('div')`
  width: 28px;
  height: 28px;
  border: 3px solid #E8F0FF;
  border-top-color: #2B6BF3;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`
